import React from 'react';
import Row from 'antd/es/row';
import Col from 'antd/es/col';
import Icon from 'antd/es/icon';
import Button from 'antd/es/button';
import Input from 'antd/es/input';
import Form from 'antd/es/form';
import Alert from 'antd/es/alert';
import {client} from '../../apollo/apolloClient';
import {GET_LOGIN_QUERY} from '../../apollo/schema';

class WrappedNavbarLogin extends React.Component {

  state = {
    showAlert: false,
  };

  handleLoginSubmit = (e) => {
    e.preventDefault();
    const {form} = this.props;
    form.validateFields((err, values) => {
      if (!err) {
        values['email'] = values['email'].toLowerCase();
        client.query({
          query: GET_LOGIN_QUERY,
          variables: {
            email: values.email,
            password: values.password,
          },
        }).then((res) => {
          if (res.hasOwnProperty('errors')) {
            this.setState({
              showAlert: true,
            });
          } else {
            window.location.reload();
          }
        }).catch(res => {
          this.setState({
            showAlert: true,
          });
        });
      }
    });
  };

  forgotPassword = (e) => {
    e.preventDefault();
    window.location.href = '/forgot-password/';
  };

  render() {
    const {form: {getFieldDecorator}, handleFormDisplay, inPage} = this.props;
    const {showAlert} = this.state;
    return (
        <Form onSubmit={this.handleLoginSubmit}>
          <Form.Item className="text-center">
            <img
                src={'https://assets-new.medcampus.io/assets/images/medcampus-icon.jpg'}
                width={150}
                alt={'logo'}
            />
          </Form.Item>
          <Form.Item>
            {
              getFieldDecorator('email', {
                rules: [
                  {
                    required: true,
                    message: 'Please input your username!',
                  }],
              })(
                  <Input
                      size="large"
                      prefix={<Icon
                          type="user"
                          style={{color: 'rgba(0,0,0,.25)'}}
                      />}
                      placeholder="Email/Username"
                  />,
              )
            }
          </Form.Item>
          <Form.Item>
            {
              getFieldDecorator('password', {
                rules: [
                  {
                    required: true,
                    message: 'Please input your Password!',
                  }],
              })(
                  <Input.Password
                      size="large"
                      prefix={<Icon
                          type="lock"
                          style={{color: 'rgba(0,0,0,.25)'}}
                      />}
                      placeholder="Password"/>,
              )
            }
          </Form.Item>
          <Button
              type="primary"
              shape={'round'}
              htmlType="submit"
              className="login-form-button"
              block
          >Log in</Button>
          <Row className="mc-mt-10">
            {
              inPage === undefined ?
                  (
                      <>
                        <Col span={12}>
                          <p>Or <span style={{cursor: 'pointer', color: '#1890ff'}} onClick={handleFormDisplay}>register now!</span></p>
                        </Col>
                        <Col span={12} className="text-right">
                          <a href="javascript:void(0);"
                             onClick={this.forgotPassword}> Forgot Password</a>
                        </Col>
                      </>
                  ) : (
                      <Col span={24} className="text-center">
                        <a href="javascript:void(0);" onClick={this.forgotPassword}> Forgot Password</a>
                      </Col>
                  )
            }
          </Row>
          {
            showAlert && <Row className="text-center">
              <Col span={24}>
                <Alert
                    message={'Email or Password is invalid'}
                    type={'error'}
                    showIcon
                />
              </Col>
            </Row>
          }
        </Form>
    );
  }
}

const NavbarLogin = Form.create({name: 'navbar-login'})(WrappedNavbarLogin);

export {NavbarLogin};
